import type { IconSvgObject } from './types';

const BorderRight02Icon: IconSvgObject = [
  ["path", { d: "M17.5 2.5H18.5C20.1569 2.5 21.5 3.84315 21.5 5.5V18.5C21.5 20.1569 20.1569 21.5 18.5 21.5H17.5M14 2.5H10M10 21.5H14M6.25 21.5H5.5C3.84315 21.5 2.5 20.1569 2.5 18.5V17.75M2.5 10V14M2.5 6.25V5.5C2.5 3.84315 3.84315 2.5 5.5 2.5H6.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default BorderRight02Icon;
